//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ObjectList',
  data() {
    return {};
  },
  mounted() {},
};
